module.exports = __webpack_public_path__ + "static/img/15.2c1f0240.png";